import React from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Container, Row, Col, Card, CardBody, CardTitle, CardText } from "reactstrap";
import { useParams } from 'react-router-dom';

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

    const RequestRejected = () => {
         const {no} = useParams()
        return (
            <>
                <div className="page-content">
                    <MetaTags>
                    <title>Rejected | BRIDGE</title>
                    </MetaTags>
                    <Container fluid={true}>
                        <Breadcrumbs title="Human Resource Management" breadcrumbItem="Rejected" />
                        <Row className="d-flex justify-content-center">
                                <Col lg={8} >
                                <Card outline color="danger" className="border">
                                    <CardBody>
                                    <CardTitle className="mb-4 text-white">
                                        
                                    </CardTitle>
                                    <CardText>
                                        
                                    </CardText>
                                    <div className="text-center">
                                        <div className="mb-4">
                                        <i className="mdi mdi-check-circle-outline text-danger display-4" />
                                        </div>
                                        <div>
                                        <h5>Rejected</h5>
                                        <p className="text-muted">
                                                Document <strong>{no}</strong> Has Been Rejected and Send Back to Sender!
                                        </p>
                                        </div>
                                    </div>
                                    </CardBody>
                                </Card>
                                </Col>
                            </Row>
                        
                           

                    </Container>
                </div>
            </>
        );
    }

export default RequestRejected;